export default __webpack_public_path__ + "static/media/slide-1.dd7411e5.jpg";